export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_07.90301202.jpg";